
import type { EligibilityCheck, HelocDrawRecord } from '@ld.consumer-portal/models';
import { MOCK_BALANCES, MOCK_BANK_ACCOUNTS, MOCK_DATES, MOCK_LOANS } from './shared.mock';

export const helocLoanInfoMock = {
  'draw-eligible': {
    loanNumber: MOCK_LOANS.heloc.loanNumber,
    annualInterestRate: 8.5,
    ytdInterestPaid: 1250.0,
    priorYearInterestPaid: 3500.0,
    availableHELOCAmount: MOCK_BALANCES.heloc.availableCredit,
    helocLimitAmount: MOCK_BALANCES.heloc.creditLimit,
    noteDate: '2022-06-15',
    nextPaymentDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    currentPrincipalBalance: MOCK_BALANCES.heloc.unpaidPrincipal,
    currentInterestAmount: 125.45,
    remainingTerm: 180,
    originalTerm: 240,
    loanMaturityDate: '2042-06-15',
    closingDate: '2022-06-15',
    fees: null,
    paymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalFeeAmount: 0,
    currentBillPrincipalInterestAmount: MOCK_BALANCES.heloc.minPayment,
    amountDueOnTime: MOCK_BALANCES.heloc.paymentDue,
    isBillGenerated: true,
    lastPaymentAmount: 350.0,
    lastPaymentDate: MOCK_DATES.paymentDate(30),
    showReturnAfter16thMessage: false,
    totalPaymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalPrincipalInterestAmount: MOCK_BALANCES.heloc.minPayment,
    paymentsDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.heloc.minPayment,
        principalAndInterest: MOCK_BALANCES.heloc.minPayment,
        taxAndInsurance: 0,
        isSuspense: false,
      },
    ],
    eligibilityCheck: [
      { type: 'Draw', eligibility: { isEligible: true, errors: [] } },
      { type: 'Payment', eligibility: { isEligible: true, errors: [] } },
    ] as EligibilityCheck[],
  },

  'draw-ineligible': {
    loanNumber: MOCK_LOANS.heloc.loanNumber,
    annualInterestRate: 8.5,
    ytdInterestPaid: 2500.0,
    priorYearInterestPaid: 4200.0,
    availableHELOCAmount: 0,
    helocLimitAmount: MOCK_BALANCES.heloc.creditLimit,
    noteDate: '2022-06-15',
    nextPaymentDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    currentPrincipalBalance: MOCK_BALANCES.heloc.creditLimit,
    currentInterestAmount: 250.0,
    remainingTerm: 180,
    originalTerm: 240,
    loanMaturityDate: '2042-06-15',
    closingDate: '2022-06-15',
    fees: null,
    paymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalFeeAmount: 0,
    currentBillPrincipalInterestAmount: MOCK_BALANCES.heloc.paymentDue,
    amountDueOnTime: MOCK_BALANCES.heloc.paymentDue,
    isBillGenerated: true,
    lastPaymentAmount: 500.0,
    lastPaymentDate: MOCK_DATES.paymentDate(30),
    showReturnAfter16thMessage: false,
    totalPaymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalPrincipalInterestAmount: MOCK_BALANCES.heloc.paymentDue,
    paymentsDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.heloc.paymentDue,
        principalAndInterest: MOCK_BALANCES.heloc.paymentDue,
        taxAndInsurance: 0,
        isSuspense: false,
      },
    ],
    eligibilityCheck: [
      {
        type: 'Draw',
        eligibility: {
          isEligible: false,
          errors: [{ errorMessage: 'No available credit. Your credit line is fully utilized.', exceptionType: 'HardStop' }],
        },
      },
      { type: 'Payment', eligibility: { isEligible: true, errors: [] } },
    ] as EligibilityCheck[],
  },

  'disaster-area': {
    loanNumber: MOCK_LOANS.heloc.loanNumber,
    annualInterestRate: 8.5,
    ytdInterestPaid: 2500.0,
    priorYearInterestPaid: 4200.0,
    availableHELOCAmount: MOCK_BALANCES.heloc.availableCredit,
    helocLimitAmount: MOCK_BALANCES.heloc.creditLimit,
    noteDate: '2022-06-15',
    nextPaymentDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    currentPrincipalBalance: MOCK_BALANCES.heloc.unpaidPrincipal,
    currentInterestAmount: 250.0,
    remainingTerm: 180,
    originalTerm: 240,
    loanMaturityDate: '2042-06-15',
    closingDate: '2022-06-15',
    fees: null,
    paymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalFeeAmount: 0,
    currentBillPrincipalInterestAmount: MOCK_BALANCES.heloc.paymentDue,
    amountDueOnTime: MOCK_BALANCES.heloc.paymentDue,
    isBillGenerated: true,
    lastPaymentAmount: 500.0,
    lastPaymentDate: MOCK_DATES.paymentDate(30),
    showReturnAfter16thMessage: false,
    totalPaymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalPrincipalInterestAmount: MOCK_BALANCES.heloc.paymentDue,
    helocAdvanceStop: '8',
    paymentsDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.heloc.paymentDue,
        principalAndInterest: MOCK_BALANCES.heloc.paymentDue,
        taxAndInsurance: 0,
        isSuspense: false,
      },
    ],
    eligibilityCheck: [
      {
        type: 'Draw',
        eligibility: {
          isEligible: false,
          errors: [
            {
              errorCode: 'AdvanceStop',
              errorMessage:
                '<div class="SEND_SECURE_MESSAGE_DISASTER">Due to the disaster in your area, a property confirmation is required before we can approve the draw request.</div>',
              exceptionType: 'HardStop',
            },
          ],
        },
      },
      { type: 'Payment', eligibility: { isEligible: true, errors: [] } },
    ] as EligibilityCheck[],
  },

  'disaster-area-delinquent': {
    loanNumber: MOCK_LOANS.heloc.loanNumber,
    annualInterestRate: 8.5,
    ytdInterestPaid: 2500.0,
    priorYearInterestPaid: 4200.0,
    availableHELOCAmount: MOCK_BALANCES.heloc.availableCredit,
    helocLimitAmount: MOCK_BALANCES.heloc.creditLimit,
    noteDate: '2022-06-15',
    nextPaymentDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    currentPrincipalBalance: MOCK_BALANCES.heloc.unpaidPrincipal,
    currentInterestAmount: 250.0,
    remainingTerm: 180,
    originalTerm: 240,
    loanMaturityDate: '2042-06-15',
    closingDate: '2022-06-15',
    fees: null,
    paymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalFeeAmount: 0,
    currentBillPrincipalInterestAmount: MOCK_BALANCES.heloc.paymentDue,
    amountDueOnTime: MOCK_BALANCES.heloc.paymentDue,
    isBillGenerated: true,
    lastPaymentAmount: 500.0,
    lastPaymentDate: MOCK_DATES.paymentDate(30),
    showReturnAfter16thMessage: false,
    totalPaymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalPrincipalInterestAmount: MOCK_BALANCES.heloc.paymentDue,
    helocAdvanceStop: '9',
    paymentsDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.heloc.paymentDue,
        principalAndInterest: MOCK_BALANCES.heloc.paymentDue,
        taxAndInsurance: 0,
        isSuspense: false,
      },
    ],
    eligibilityCheck: [
      {
        type: 'Draw',
        eligibility: {
          isEligible: false,
          errors: [
            {
              errorCode: 'DelinquentLoan',
              errorMessage:
                'Your HELOC account is currently ineligible to request an advance due to delinquency.',
              exceptionType: 'HardStop',
            },
          ],
        },
      },
      { type: 'Payment', eligibility: { isEligible: true, errors: [] } },
    ] as EligibilityCheck[],
  },

  'repayment-phase': {
    loanNumber: MOCK_LOANS.heloc.loanNumber,
    annualInterestRate: 8.5,
    ytdInterestPaid: 1800.0,
    priorYearInterestPaid: 3800.0,
    availableHELOCAmount: 0,
    helocLimitAmount: MOCK_BALANCES.heloc.creditLimit,
    noteDate: '2015-06-15',
    nextPaymentDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    currentPrincipalBalance: MOCK_BALANCES.heloc.unpaidPrincipal,
    currentInterestAmount: 175.0,
    remainingTerm: 60,
    originalTerm: 240,
    loanMaturityDate: '2035-06-15',
    closingDate: '2015-06-15',
    fees: null,
    paymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalFeeAmount: 0,
    currentBillPrincipalInterestAmount: MOCK_BALANCES.heloc.paymentDue,
    amountDueOnTime: MOCK_BALANCES.heloc.paymentDue,
    isBillGenerated: true,
    lastPaymentAmount: 450.0,
    lastPaymentDate: MOCK_DATES.paymentDate(30),
    showReturnAfter16thMessage: true,
    totalPaymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalPrincipalInterestAmount: MOCK_BALANCES.heloc.paymentDue,
    paymentsDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.heloc.paymentDue,
        principalAndInterest: MOCK_BALANCES.heloc.paymentDue,
        taxAndInsurance: 0,
        isSuspense: false,
      },
    ],
    eligibilityCheck: [
      {
        type: 'Draw',
        eligibility: {
          isEligible: false,
          errors: [{ errorMessage: 'Draw period has ended. Your account is in the repayment phase.', exceptionType: 'HardStop' }],
        },
      },
      { type: 'Payment', eligibility: { isEligible: true, errors: [] } },
    ] as EligibilityCheck[],
  },

  'with-fees': {
    loanNumber: MOCK_LOANS.heloc.loanNumber,
    annualInterestRate: 8.5,
    ytdInterestPaid: 1250.0,
    priorYearInterestPaid: 3500.0,
    availableHELOCAmount: MOCK_BALANCES.heloc.availableCredit,
    helocLimitAmount: MOCK_BALANCES.heloc.creditLimit,
    noteDate: '2022-06-15',
    nextPaymentDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    currentPrincipalBalance: MOCK_BALANCES.heloc.unpaidPrincipal,
    currentInterestAmount: 125.45,
    remainingTerm: 180,
    originalTerm: 240,
    loanMaturityDate: '2042-06-15',
    closingDate: '2022-06-15',
    fees: null,
    paymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalFeeAmount: 75.0,
    currentBillPrincipalInterestAmount: MOCK_BALANCES.heloc.minPayment,
    amountDueOnTime: MOCK_BALANCES.heloc.paymentDue,
    isBillGenerated: true,
    lastPaymentAmount: 350.0,
    lastPaymentDate: MOCK_DATES.paymentDate(30),
    showReturnAfter16thMessage: false,
    totalPaymentDue: MOCK_BALANCES.heloc.paymentDue + 75.0,
    totalPrincipalInterestAmount: MOCK_BALANCES.heloc.minPayment,
    paymentsDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.heloc.minPayment,
        principalAndInterest: MOCK_BALANCES.heloc.minPayment,
        taxAndInsurance: 0,
        isSuspense: false,
      },
    ],
    eligibilityCheck: [
      { type: 'Draw', eligibility: { isEligible: true, errors: [] } },
      { type: 'Payment', eligibility: { isEligible: true, errors: [] } },
    ] as EligibilityCheck[],
  },

  'draw-pending': {
    loanNumber: MOCK_LOANS.heloc.loanNumber,
    annualInterestRate: 8.5,
    ytdInterestPaid: 1250.0,
    priorYearInterestPaid: 3500.0,
    availableHELOCAmount: MOCK_BALANCES.heloc.availableCredit - 5000,
    helocLimitAmount: MOCK_BALANCES.heloc.creditLimit,
    noteDate: '2022-06-15',
    nextPaymentDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    currentPrincipalBalance: MOCK_BALANCES.heloc.unpaidPrincipal + 5000,
    currentInterestAmount: 125.45,
    remainingTerm: 180,
    originalTerm: 240,
    loanMaturityDate: '2042-06-15',
    closingDate: '2022-06-15',
    fees: null,
    paymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalFeeAmount: 0,
    currentBillPrincipalInterestAmount: MOCK_BALANCES.heloc.minPayment,
    amountDueOnTime: MOCK_BALANCES.heloc.paymentDue,
    isBillGenerated: true,
    lastPaymentAmount: 350.0,
    lastPaymentDate: MOCK_DATES.paymentDate(30),
    showReturnAfter16thMessage: false,
    totalPaymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalPrincipalInterestAmount: MOCK_BALANCES.heloc.minPayment,
    paymentsDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.heloc.minPayment,
        principalAndInterest: MOCK_BALANCES.heloc.minPayment,
        taxAndInsurance: 0,
        isSuspense: false,
      },
    ],
    drawEligibilityStatus: 'Pending' as const,
    eligibilityCheck: [
      { type: 'Draw', eligibility: { isEligible: true, errors: [] } },
      { type: 'Payment', eligibility: { isEligible: true, errors: [] } },
    ] as EligibilityCheck[],
  },

  frozen: {
    loanNumber: MOCK_LOANS.heloc.loanNumber,
    annualInterestRate: 8.5,
    ytdInterestPaid: 1500.0,
    priorYearInterestPaid: 3600.0,
    availableHELOCAmount: 0,
    helocLimitAmount: MOCK_BALANCES.heloc.creditLimit,
    noteDate: '2022-06-15',
    nextPaymentDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    currentPrincipalBalance: MOCK_BALANCES.heloc.unpaidPrincipal,
    currentInterestAmount: 150.0,
    remainingTerm: 180,
    originalTerm: 240,
    loanMaturityDate: '2042-06-15',
    closingDate: '2022-06-15',
    fees: null,
    paymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalFeeAmount: 0,
    currentBillPrincipalInterestAmount: MOCK_BALANCES.heloc.paymentDue,
    amountDueOnTime: MOCK_BALANCES.heloc.paymentDue,
    isBillGenerated: true,
    lastPaymentAmount: 400.0,
    lastPaymentDate: MOCK_DATES.paymentDate(30),
    showReturnAfter16thMessage: false,
    totalPaymentDue: MOCK_BALANCES.heloc.paymentDue,
    totalPrincipalInterestAmount: MOCK_BALANCES.heloc.paymentDue,
    paymentsDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.heloc.paymentDue,
        principalAndInterest: MOCK_BALANCES.heloc.paymentDue,
        taxAndInsurance: 0,
        isSuspense: false,
      },
    ],
    eligibilityCheck: [
      {
        type: 'Draw',
        eligibility: {
          isEligible: false,
          errors: [{ errorMessage: 'Your account is currently frozen. Please contact customer support.', exceptionType: 'HardStop' }],
        },
      },
      {
        type: 'Payment',
        eligibility: {
          isEligible: false,
          errors: [{ errorMessage: 'Your account is currently frozen. Please contact customer support.', exceptionType: 'HardStop' }],
        },
      },
    ] as EligibilityCheck[],
  },
};

export const drawEligibilityMock = {
  eligible: {
    isEligible: true,
    availableCredit: MOCK_BALANCES.heloc.availableCredit,
    minDrawAmount: 1000,
    maxDrawAmount: MOCK_BALANCES.heloc.availableCredit,
    message: '',
  },

  'no-credit': {
    isEligible: false,
    availableCredit: 0,
    minDrawAmount: 0,
    maxDrawAmount: 0,
    message: 'No available credit. Your credit line is fully utilized.',
  },

  ineligible: {
    isEligible: false,
    availableCredit: 0,
    minDrawAmount: 0,
    maxDrawAmount: 0,
    message: 'Draw period has ended. Your account is in the repayment phase.',
  },

  frozen: {
    isEligible: false,
    availableCredit: 0,
    minDrawAmount: 0,
    maxDrawAmount: 0,
    message: 'Your account is currently frozen. Please contact customer support.',
  },

  'draw-daily-limit': {
    isEligible: true,
    availableCredit: MOCK_BALANCES.heloc.availableCredit,
    minDrawAmount: 1000,
    maxDrawAmount: MOCK_BALANCES.heloc.availableCredit,
    message: '',
    pendingDraws: [
      {
        drawRecordID: 'DR-TODAY-001',
        loanNumber: MOCK_LOANS.heloc.loanNumber,
        transactionAmount: 5000,
        transactionStartDate: new Date().toISOString(),
        drawStatus: 'Pending',
        confirmationNumber: 'DRAW-TODAY-001',
      },
    ],
  },
};

export const drawFundsMock = {
  success: {
    isSuccess: true,
    confirmationNumber: `DRAW-${Date.now()}`,
    drawAmount: 5000.0,
    newBalance: MOCK_BALANCES.heloc.unpaidPrincipal + 5000.0,
    newAvailableCredit: MOCK_BALANCES.heloc.availableCredit - 5000.0,
    disbursementDate: MOCK_DATES.futureDate(2),
    message: 'Funds will be deposited within 2 business days.',
  },
  'insufficient-credit': {
    isSuccess: false,
    confirmationNumber: '',
    message: 'Requested amount exceeds available credit.',
  },
  'below-minimum': {
    isSuccess: false,
    confirmationNumber: '',
    message: 'Draw amount must be at least $1,000.',
  },
  error: {
    isSuccess: false,
    confirmationNumber: '',
    message: 'Unable to process draw request. Please try again.',
  },
};

export const helocPendingDrawRecordsMock: Record<string, HelocDrawRecord[]> = {
  'no-pending': [],

  'single-pending': [
    {
      drawRecordID: 'DR-MOCK-001',
      loanNumber: MOCK_LOANS.heloc.loanNumber,
      transactionAmount: 5000,
      transactionStartDate: MOCK_DATES.paymentDate(1),
      drawStatus: 'Processing',
      drawStatusID: 6,
      confirmationNumber: 'DRAW-CONF-001',
    },
  ],

  'multiple-pending': [
    {
      drawRecordID: 'DR-MOCK-002',
      loanNumber: MOCK_LOANS.heloc.loanNumber,
      transactionAmount: 3000,
      transactionStartDate: MOCK_DATES.paymentDate(1),
      drawStatus: 'Processing',
      drawStatusID: 6,
      confirmationNumber: 'DRAW-CONF-002',
    },
    {
      drawRecordID: 'DR-MOCK-003',
      loanNumber: MOCK_LOANS.heloc.loanNumber,
      transactionAmount: 2000,
      transactionStartDate: MOCK_DATES.paymentDate(3),
      drawStatus: 'Processing',
      drawStatusID: 6,
      confirmationNumber: 'DRAW-CONF-003',
    },
  ],
};

export const helocAutopayStatusMock = {
  enabled: {
    isEnabled: true,
    paymentAmount: MOCK_BALANCES.heloc.minPayment,
    paymentType: 'Minimum Payment',
    nextPaymentDate: MOCK_DATES.paymentDueDate().toISOString(),
    bankAccount: {
      profileId: MOCK_BANK_ACCOUNTS.chase.profileId,
      lastFour: MOCK_BANK_ACCOUNTS.chase.lastFourAccountNumber,
      bankName: MOCK_BANK_ACCOUNTS.chase.bankName,
      accountType: MOCK_BANK_ACCOUNTS.chase.accountType,
    },
  },

  disabled: {
    isEnabled: false,
    paymentAmount: 0,
    paymentType: '',
    nextPaymentDate: null,
    bankAccount: null,
  },

  'full-balance': {
    isEnabled: true,
    paymentAmount: MOCK_BALANCES.heloc.unpaidPrincipal,
    paymentType: 'Statement Balance',
    nextPaymentDate: MOCK_DATES.paymentDueDate().toISOString(),
    bankAccount: {
      profileId: MOCK_BANK_ACCOUNTS.chase.profileId,
      lastFour: MOCK_BANK_ACCOUNTS.chase.lastFourAccountNumber,
      bankName: MOCK_BANK_ACCOUNTS.chase.bankName,
      accountType: MOCK_BANK_ACCOUNTS.chase.accountType,
    },
  },
};
